(() => {
  if (!window.componentJSInitialized) {
    window.componentJSInitialized = true;
    document.addEventListener('DOMContentLoaded', () => {
      // CRITICAL FIX: Removed duplicate .mag-banner click/keydown handlers
      // Navigation is now exclusively handled by destini.liquid's publishDestiniStoreLocatorClick()
      // which includes proper analytics tracking and synchronous click-data persistence
      // This eliminates the race condition where both handlers fire on the same click
      
      const videoWrappers = document.querySelectorAll('.banner-video-wrapper, .slideshow-video-wrapper');
      videoWrappers.forEach((wrapper) => {
        const video = wrapper.querySelector('video');
        if (!video) return;
        try {
          video.setAttribute('tabindex', '-1');
        } catch {
          //ignore if setting tabindex fails, e.g. if the video is an unsupported format and treated as an image
        }

        const placeholder = wrapper.querySelector('.video-placeholder');

        function hidePlaceholder() {
          if (!placeholder) return;
          placeholder.style.display = 'none';
          // show controls again if they exist
          const playBtn = wrapper.querySelector(
            '.banner-video-play-pause, .slideshow-video-play-pause, .video-play-toggle',
          );
          const muteBtn = wrapper.querySelector(
            '.banner-video-mute-unmute, .slideshow-video-mute-unmute, .video-sound-toggle',
          );
          if (playBtn) playBtn.style.display = 'flex';
          if (muteBtn) muteBtn.style.display = 'flex';
        }

        function showPlaceholder() {
          if (!placeholder) return;
          // clear inline style to let CSS show it (CSS no longer forces display:none)
          placeholder.style.display = '';
          // hide controls when placeholder is visible
          const playBtn = wrapper.querySelector(
            '.banner-video-play-pause, .slideshow-video-play-pause, .video-play-toggle',
          );
          const muteBtn = wrapper.querySelector(
            '.banner-video-mute-unmute, .slideshow-video-mute-unmute, .video-sound-toggle',
          );
          if (playBtn) playBtn.style.display = 'none';
          if (muteBtn) muteBtn.style.display = 'none';
        }

        // If the video already has data, hide placeholder immediately
        if (video.readyState && video.readyState > 0) {
          hidePlaceholder();
        } else {
          showPlaceholder();
        }
        video.addEventListener('loadeddata', hidePlaceholder);
        video.addEventListener('playing', hidePlaceholder);
        video.addEventListener('error', showPlaceholder);
        // Only show placeholder for stalled if the video truly has no data or an error.
        const handleStalled = () => {
          const hasError = !!video.error;
          const noData = video.readyState === 0; // HAVE_NOTHING
          if (hasError || noData) showPlaceholder();
        };
        video.addEventListener('stalled', handleStalled);
        video.addEventListener('emptied', showPlaceholder);
      });
    });
  }
})();
